//import {RequestHandler} from '../service/OffService/request-handler';

export class Utils {

    public static es = {
        firstDayOfWeek: 1,
        dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
        dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
        dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
        monthNames: ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'],
        monthNamesShort: ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'],
        today: 'Hoy',
        clear: 'Borrar'
    };

    public static isNumber(input: string): boolean {
        return /^[0-9]+([,|.][0-9]+)?$/.test(input + '');
    }

    public static isSet(...values: any[]): boolean {
        if (values) for (let item of values) {
            if (item === undefined || item === null) {
                return false;
            }
        }

        return true;
    }

    public static replaceAll(str, search, replacement): string {
        return str.replace(new RegExp(search, 'g'), replacement);
    }

    public static decimalFormat(input: any, nDecimals?: number, millar?: string, comma?: string) {
        if (nDecimals === undefined) {
            nDecimals = 0;
        }

        if (millar === undefined) {
            millar = '.';
        }

        if (comma === undefined) {
            comma = ',';
        }

        if (input) {
            let rest;

            if (String.prototype.constructor === input.constructor) {
                rest = parseFloat(input).toFixed(nDecimals).replace('.', ',');
            } else {
                rest = input.toFixed(nDecimals).replace('.', ',');
            }

            const hasDecimals = rest.indexOf(',') !== -1;
            let startIndex;

            if (hasDecimals) {
                startIndex = rest.indexOf(',') - 1;
            } else {
                startIndex = rest.length - 1;
            }

            let finalString = '';
            let count = -1;

            for (let index = startIndex; index >= 0; index--) {
                const element = rest[index];

                if (++count === 3) {
                    finalString += millar;
                    count = 0;
                }

                finalString += element;
            }

            if (hasDecimals) {
                return finalString.split('').reverse().join('') + comma + rest.split(',')[1];
            } else {
                return finalString.split('').reverse().join('');
            }
        } else {
            let output = '0';

            if (nDecimals > 0) {
                output += comma;
                for (let i = 0; i < nDecimals; i++) {
                    output += '0';
                }
            }

            return output;
        }
    }

    public static preparePrice(input: any) {
        let replaced = Utils.decimalFormat(input).replace('.', '');
        replaced = replaced.replace(',', '');
        replaced = replaced.replace(' ', '');

        return replaced;
    }

    public static b64encode(str: string): string {
        return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
            function toSolidBytes(match, p1) {
                return String.fromCharCode(parseInt('0x' + p1));
            }));
    }

    public static b64decode(str: string): string {
        return decodeURIComponent(atob(str).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }

    public static formatDate(date: Date | string) {
        if (date) {
            if (date.constructor === String.prototype.constructor) {
                const splited = (date as string).split('/');
                date = new Date(splited[1] + '/' + splited[0] + '/' + splited[2]);

                let day = date.getDate();
                if (day <= 9) {
                    day = '0' + day as any;
                }
                let month = date.getMonth() + 1;
                if (month <= 9) {
                    month = '0' + month as any;
                }

                return day + '/' + month + '/' + date.getFullYear();
            } else if (date.constructor === Date.prototype.constructor) {
                let day = (date as Date).getDate();
                if (day <= 9) {
                    day = '0' + day as any;
                }
                let month = (date as Date).getMonth() + 1;
                if (month <= 9) {
                    month = '0' + month as any;
                }
                return day + '/' + month + '/' + (date as Date).getFullYear();
            } else {
                throw new Error('Utils.formatDate: Try to formating [' + date.constructor.name + '], Admited types [Date | String]');
            }
        } else {
            throw new Error('Utils.formatDate: Try to formating null | undefined date');
        }
    }

    public static toDate(date: string): Date {
        if ((/((([1-9]|0[1-9]|[12]\d|3[01])[-/]([1-9]|0[1-9]|1[0-2])[-/][12]\d{3}))/).test(date)) {
            const splited = (date as string).split('/');
            return new Date(splited[1] + '/' + splited[0] + '/' + splited[2]) || null;
        } else {
            return null;
        }
    }

    public static fechaDeHoyYYYYMMDD() {
        let today = new Date();
        return today;
       
      }
    
      public static arreglarfecha(fecha) {
        let arregloFecha = fecha.split("/");
        let today = new Date(arregloFecha[2], arregloFecha[1], arregloFecha[0]);
    
        let dd = today.getDate();
        let DD = "";
        var mm = today.getMonth(); //January is 0!
        let MM = "";
        var yyyy = today.getFullYear();
        if (mm < 10) {
          MM = "0" + mm;
        } else {
          MM = "" + mm;
        }
        if (dd < 10) {
          DD = "0" + dd;
        } else {
          DD = "" + dd;
        }
    
        let myfecha = MM + '/' + DD + '/' + yyyy;
        myfecha = yyyy + '-' + MM + '-' + DD;
        // console.log(myfecha);
        return myfecha;
      }


    /*
    public static unsuscribe(requests: RequestHandler[]) {
        (requests || []).forEach(req => {
            (req || {unsuscribe: () => false}).unsuscribe();
        });
    }
    */
}